// DS: i1.7
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Fragments: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M12.021 19.648a2.571 2.571 0 0 1 1.626-1.626l1.353-.45-1.353-.45a2.575 2.575 0 0 1-1.626-1.627l-.45-1.352-.45 1.352a2.575 2.575 0 0 1-1.626 1.626l-1.352.45 1.352.451c.767.256 1.37.858 1.626 1.626L11.57 21l.45-1.352ZM6.88 14.505a2.571 2.571 0 0 1 1.626-1.626l1.352-.45-1.352-.45a2.575 2.575 0 0 1-1.626-1.627L6.429 9l-.451 1.352a2.575 2.575 0 0 1-1.626 1.627L3 12.429l1.352.45c.767.256 1.37.858 1.626 1.626l.45 1.352.45-1.352ZM15 15l-.867-2.602a4.003 4.003 0 0 0-2.53-2.53L9 9l2.602-.867a4.001 4.001 0 0 0 2.53-2.53L15 3l.867 2.602a4.001 4.001 0 0 0 2.53 2.53L21 9l-2.603.867a4.003 4.003 0 0 0-2.53 2.53L15 15Z"
          clipRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};

Fragments.displayName = 'Fragments';

export default Fragments;
